import { Inject, Injectable } from '@angular/core';
import { AppService } from '../../app.service';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class SettlementConfigService {

  private _apiBaseUrl: string = '';

  public constructor(private appService: AppService, public http: HttpClient, @Inject('API_BASE_URL') baseurl: string) {
    this._apiBaseUrl = baseurl;
  }

  public getSettlementSetting = (HasSettlement: boolean): Observable<any> => {
    const apipath: string = 'settlementsetting/creditor?HasSettlement='+HasSettlement;
    const fullPath: string = this._apiBaseUrl + apipath;
    const options = this.appService.getHttpHeaderOptions();

    return this.http.get<any>(fullPath, options);
  }

  public updateSettlementStatus = (CreditorId: string, IsSettlementPaymentEnabled: number, SettlementTypeId: number): Observable<any> => {
    const apipath: string = 'settlementsetting/Settlementr-status';
    const fullPath: string = this._apiBaseUrl + apipath;
    const options = this.appService.getHttpHeaderOptions();
    const params: any = { CreditorId: +CreditorId, IsSettlementPaymentEnabled: IsSettlementPaymentEnabled, SettlementTypeId: +SettlementTypeId};

    return this.http.put<any>(fullPath, params, options);
  }

  public updateSettlementOfferStatus = (Id: number, IsActive: number): Observable<any> => {
    const apipath: string = 'settlementsetting/offer-status';
    const fullPath: string = this._apiBaseUrl + apipath;
    const options = this.appService.getHttpHeaderOptions();
    const params: any = { Id: Id, IsActive: IsActive};

    return this.http.put<any>(fullPath, params, options);
  }

  public getSettlementListOffer = (CreditorId: string, SettlementTypeId: number): Observable<any> => {
    const apipath: string = `settlementsetting/list-offer/${CreditorId}/${SettlementTypeId}?limit=100&offset=0`;
    const fullPath: string = this._apiBaseUrl + apipath;
    const options = this.appService.getHttpHeaderOptions();

    return this.http.get<any>(fullPath, options);
  }

  public updateSettlementOffer = (data: any): Observable<any> => {
    const apipath: string = 'settlementsetting/update-offer';
    const fullPath: string = this._apiBaseUrl + apipath;
    const options = this.appService.getHttpHeaderOptions();
    const params: any = data;

    return this.http.put<any>(fullPath, params, options);
  }

  public createSettlementOffer = (data: any): Observable<any> => {
    const apipath: string = 'settlementsetting/create-offer';
    const fullPath: string = this._apiBaseUrl + apipath;
    const options = this.appService.getHttpHeaderOptions();
    const params: any = data;

    return this.http.post<any>(fullPath, params, options);
  }

    public getSettlementFrequency = (CreditorId: string): Observable<any> => {
    const apipath: string = `settlementsetting/frequency/${CreditorId}`;
    const fullPath: string = this._apiBaseUrl + apipath;
    const options = this.appService.getHttpHeaderOptions();

    return this.http.get<any>(fullPath, options);
  }

  public deleteSettlementOffer = (Id: string): Observable<any> => {
    const apipath: string = `settlementsetting/delete-offerd/${Id}`;
    const fullPath: string = this._apiBaseUrl + apipath;
    const options = this.appService.getHttpHeaderOptions();
    return this.http.delete<any>(fullPath, options);
  }
}